var __jsx = React.createElement;
import Head from 'next/head';
import React from 'react';
import { useIdentify } from '@webtv/analytics';
import { SegmentScript } from '@webtv/analytics/SegmentScript';
import useReportAppInstall from '@webtv/analytics/useReportAppInstall';
import useStartSession from '@webtv/analytics/useStartSession';
import { useLastBrowseCategory } from '@webtv/data-fetch';
import { BASE_PATH, OPTIMIZELY_KEY, PELOTON_PLATFORM, SEGMENT_KEY } from '@webtv/env';
import { OptimizelyScript } from '@webtv/feature-toggles/OptimizelyScript';
import { usePersistedWatchTimeMetrics } from '@webtv/persist-watch-time';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeadScripts = function HeadScripts() {
  var css = "\n    @font-face {\n      font-family: 'InterV';\n      src: url('".concat(BASE_PATH, "/fonts/Inter.var.woff2') format('woff2');\n      font-style: normal;\n    }\n    @font-face {\n      font-family: 'Brandon Grotesque';\n      src: url('").concat(BASE_PATH, "/fonts/BrandonGrotesqueBold700wt.woff2') format('woff2'),\n        url('").concat(BASE_PATH, "/fonts/BrandonGrotesqueBold700wt.woff') format('woff');\n\n      font-weight: 700;\n      font-style: normal;\n    }\n    body {\n      font-family: 'InterV', sans-serif;\n    }\n  }\n");
  return /*#__PURE__*/_jsxs(Head, {
    children: [PELOTON_PLATFORM === 'samsung' && /*#__PURE__*/_jsx("script", {
      type: "text/javascript",
      src: "$WEBAPIS/webapis/webapis.js"
    }), PELOTON_PLATFORM === 'lg' && /*#__PURE__*/_jsx("script", {
      type: "text/javascript",
      src: "".concat(BASE_PATH, "/scripts/webOSTV.js")
    }), /*#__PURE__*/_jsx(OptimizelyScript, {
      withKey: OPTIMIZELY_KEY
    }), /*#__PURE__*/_jsx("style", {
      children: css
    }), /*#__PURE__*/_jsx(SegmentScript, {
      withKey: SEGMENT_KEY
    })]
  });
};
export var BootupEvents = function BootupEvents() {
  useReportAppInstall();
  useStartSession();
  useIdentify();
  return null;
};
export var PersistedWatchTimeMetrics = function PersistedWatchTimeMetrics() {
  usePersistedWatchTimeMetrics();
  return null;
};
export var WatchLastBrowseCategory = function WatchLastBrowseCategory() {
  useLastBrowseCategory();
  return null;
};